<template>
    <div class="ve-list-page">
        <section v-loading="loading"></section>
        <div v-show="!v_cond" style="display:flex;border-bottom:1px solid #389">
            <div style="line-height:35px;height:35px;background:white; ">
                <!-- <span style="font-size:14px; color:#606266;font-weight:600;margin-left:5px;"><i class="iconfont icon-saomiao" ></i> 扫描增加记录</span> -->
                <el-link :underline="false" @click="invModel=true"><i class="iconfont icon-wenhaoxiao" style="font-size:14px;color:red;margin-left:5px; "></i></el-link>
                <el-link :disabled="addBool" :underline="false" @click="handAdd" style="font-size:14px; color:#409eff;font-weight:600;margin-left:15px;"><i class="iconfont icon-shoudongtongbu" ></i> {{ $LANG('1257', '手工增加记录') }}</el-link>
            </div>
            <div style="line-height:40px;height:40px;background:white;margin-top:1px;display:flex;margin-left:20px ">
                <div style="width:1000px;display:flex;"> 
                    <div  style="width:80px;padding-left:4px; line-height:40px;font-size:14px;font-weight:600" >
                        {{ $LANG('2089', '扫描二维码') }}
                    </div>
                    <el-tooltip :content="$LANG('1452', '错误的格式')" placement="bottom" effect="light" v-model="tooltip" :manual="true" >
                        <el-input :disabled="addBool" :placeholder="$LANG('1935', '请扫描发票 ( 注意： 请不要在中文输入法状态下扫描）')" ref="scan" v-model="form.scancode"  @keyup.enter.native="scanTwo" size="small"  style="width:400px;height:35px;"></el-input>
                    </el-tooltip>
                </div>
            </div>
        </div>
 
        <div style="line-height:30px;height:35px;background:white; display:flex;border-bottom:1px solid #389">
                <div class="invoice-mgt-toolbar" style="width:1200px;display:flex;padding-top:2px">
                <div style="width:70px;font-size:13px;padding-left:4px">{{ $LANG('0681', '字段查询') }}</div>
                <el-select v-model="selparam"  :placeholder="$LANG('1675', '请选择列名')" filterable size="small" style="width:150px;  ">
                    <span v-for="item in invArr" :key='item.key'>
                        <el-option :label="item.title" :value="item.key"></el-option>
                    </span>
                </el-select>
                <el-input :placeholder="$LANG('1692', '请输入查询值')" clearable v-model="txtparam" size="small" @keyup.enter.native="qryTabData" style="width:310px; height:30px; ">
                    <el-select v-model="oper" slot="prepend"   style="width:100px; " >
                        <span v-for="item in operArr" :key='item.IDSEQ'>
                            <el-option :label="item.CNAME" :value="item.SUBNO" ></el-option>
                        </span>
                    </el-select>
                    <el-button size="small" slot="append" icon="el-icon-search" @click="qryTabData" ></el-button>
                </el-input> 
                <el-select v-model="selparam2"  :placeholder="$LANG('1675', '请选择列名')" filterable size="small" style="width:150px; margin-left:5px; ">
                    <span v-for="item in invArr" :key='item.key'>
                        <el-option :label="item.title" :value="item.key"></el-option>
                    </span>
                </el-select>
 
                <el-input :placeholder="$LANG('1692', '请输入查询值')" clearable v-model="txtparam2" size="small" @keyup.enter.native="qryTabData" style="width:310px; height:30px; ">
                    <el-select v-model="oper2" slot="prepend"   style="width:100px; " >
                        <span v-for="item in operArr" :key='item.IDSEQ'>
                            <el-option :label="item.CNAME" :value="item.SUBNO" ></el-option>
                        </span>
                    </el-select>
                    <el-button size="small" slot="append" icon="el-icon-search" @click="qryTabData" ></el-button>
                </el-input> 
                
                <el-link class="invoice-mgt-toolbar__action" @click="expExcel" :underline="false">
                    <i class="iconfont icon-daochu1" style="font-size:17px;  margin-left:25px;color:#409eff"></i>
                    <span style="font-size:12px;  font-weight:600;margin-left:5px;">{{ $LANG('0136', '导出') }}EXCEL</span>
                </el-link>
                <i class="iconfont icon-ziyuan invoice-mgt-toolbar__field-icon" style="color:#409EFF;font-size:14px;margin:0 5px 0 15px;"></i>
                <el-link class="invoice-mgt-toolbar__action" @click="openFieldSettingsDialog().catch(() => {})" :underline="false"><span style="font-size:12px;margin-right:15px;">{{ $LANG('0683', '字段设置') }}</span></el-link>

            </div>
        </div>
        <div class="ve-list-page__table">
        <ve-table :columns="vueCol"
                :table-data="invData"
                :columnHiddenOption="columnHiddenOption"
                :border-around="true"
                :border-x="true"
                :border-y="true"
                :fixed-header="true"
                row-key-field-name="IDSEQ"
                :row-style-option="rowStyleOption"
                :cell-style-option="cellStyleOption"
                :max-height="tabHeight"
                :virtual-scroll-option="virtualScrollOption"
                :scroll-width="0"
                :column-width-resize-option="columnWidthResizeOption"
                :clipboardOption="{copy:true,paste:false,cut:false,delete:false}"
                :cellSelectionOption="{enable: false}"
                v-loading="loading"
                :element-loading-text="$LANG('2030', '数据加载中')"
                ref="tabref">
        </ve-table>
        </div>
        <VeColumnConfigDialog
            :visible="fieldSettingDialog.visible"
            :rows="fieldSettingDialog.rows"
            :loading="fieldSettingDialog.loading"
            :error="fieldSettingDialog.error"
            :locked-field-keys="fieldSettingDialog.lockedFieldKeys"
            :drag-group-field="fieldSettingDialog.dragGroupField"
            :language="$store.state.lang"
            @update:visible="fieldSettingDialog.visible = $event"
            @change="updateFieldSettingsDraft"
            @confirm="saveFieldSettingsDialog"
            @reset="resetFieldSettingsDialog"
            @close="closeFieldSettingsDialog"
        />
        <div class="ve-list-page__pagination">
                <div style="float: left;padding-left:5px">
                    <Page :total="dataCount" :page-size="rowSize" show-total :current="current" @on-change="changePage"></Page>
                </div>
                <span style="color:#606266; font-size:12px;width:35px;margin-left:10px ;">{{ $LANG('0349', '每页') }}</span>
                <el-select v-model="rowSize" size="small" style="width:70px;" @change="initPage">
                        <el-option 
                            v-for="item in pageList"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                        </el-option>
                </el-select>
                <span style="color:#606266; margin-left:10px;font-size:12px;width:30px;">{{ $LANG('0398', '跳至') }}</span>
                <el-input v-enter-number size="small" v-model="goPage" style="width:50px;"></el-input> 
                <span style="color:#606266;margin-left:10px ;font-size:12px;">{{ $LANG('1660', '页') }}</span>

                <el-button @click="goNext" size="small" type="primary" style="width:50px;margin-left:15px;height:32px;">GO</el-button>
                <div style="color:#f44;font-weight:600;font-size:14px;line-height:30px;margin-left:20px;">{{ $LANG('1216', '合计含税金额') }}：{{v_ttlamt}}</div>
          </div>   
        <Modal v-model="invModel" scrollable  width="480px" :footer-hide="true"  :closable="true" >
            <div style=" width:100%;font-size:14px;color:#2b85e4">
                {{ $LANG('2085', '发票格式如') }}："01,01,05001523,2936555,1200.50,20211219,,1744,"
                <ul>
                    <li style="margin-bottom:10px;margin-top:5px;">
                        1、{{ $LANG('2077', '第一个属性值：二维码的通用格式均以 01 开头') }};
                    </li>
                    <li style="margin-bottom:10px">
                        2、{{ $LANG('2078', '第二个属性值：代表发票种类代码，有三个属性值：04 是普通发票，10 是电子发票，01 是专用发票') }};
                    </li>
                    <li style="margin-bottom:10px">
                        3、{{ $LANG('2079', '第三个属性值：发票代码') }};
                    </li>
                    <li style="margin-bottom:15px">
                        4、{{ $LANG('2080', '第四个属性值：发票号码') }}
                    </li>
                    <li style="margin-bottom:10px">
                        5、{{ $LANG('2081', '第五个属性值：合计金额') }}
                    </li>
                    <li style="margin-bottom:10px">
                        6、{{ $LANG('2082', '第六个属性值：发票日期') }}
                    </li>
                    <li style="margin-bottom:10px">
                        7、{{ $LANG('2083', '第七个属性值：发票校验码。增值税专用发票没有发票校验码，没有则为空字符串') }}
                    </li>
                    <li style="margin-bottom:10px">
                        8、{{ $LANG('2084', '第八个属性值：自定义，不代表意义') }}
                    </li>
                </ul>
            </div>
            <div style="margin-bottom:10px;display:flex">
                <el-button type="primary" style="width:100%" icon="el-icon-check" @click="invModel=false">{{ $LANG('0037', '我知道了') }}</el-button>
            </div>
            <div slot="header" style="height:10px;line-height:10px">
                <span style="font-size:20px;font-weight:700">{{ $LANG('1360', '发票二维码说明') }}</span>
            </div>
        </Modal>
        <el-dialog class="pub_dialog" v-dialogDrag :show-close="false" :visible.sync="addModel" width="510px" :close-on-press-escape="false" :close-on-click-modal="false" append-to-body top="2vh">
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'38px'}">
                <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">{{ $LANG('0043', '手工增加') }} </span>
            </div>  
            <Form ref="addForm" :model="invObj" :rules="ruleValidate"  :label-width="110"  label-position="right" inline > 
                <FormItem :label="$LANG('0634', '发票分类')"   >
                    <el-select v-model="invObj.invtype"   style="width:340px;">
                        <el-option v-for="(item,index) in typeArr" :key="index" :label="item.CNAME" :value="item.CODE"></el-option>
                    </el-select>
                </FormItem>
                <FormItem :label="$LANG('0636', '发票类型')"   >
                    <el-select  v-model="invObj.invty"   class="rowcss">
                        <el-option :label="$LANG('1530', '增值税电子普通发票')" value="10"></el-option>
                        <el-option :label="$LANG('1365', '增值税普通发票')" value="04"></el-option>
                        <el-option :label="$LANG('1364', '增值税专用发票')" value="01"></el-option>
                    </el-select>
                </FormItem>
                
                <FormItem :label="$LANG('0633', '发票代码')" prop="idno"  >
                    <el-input  v-model="invObj.idno"   class="rowcss"></el-input>
                </FormItem>
                <FormItem :label="$LANG('0635', '发票号码')" prop="invno"  >
                    <el-input  v-model="invObj.invno"   class="rowcss"></el-input>
                </FormItem>
                <FormItem :label="$LANG('0023', '开票日期')"  prop="invdttm" >
                    <el-date-picker type="date"   v-model="invObj.invdttm" value-format="yyyy-MM-dd" class="rowcss"></el-date-picker> 
                </FormItem>
                <FormItem :label="$LANG('0408', '金额')"  prop="amt" >
                    <el-input-number :precision="2" v-model="invObj.amt"   class="rowcss"></el-input-number>
                </FormItem>
                <FormItem :label="$LANG('0368', '税率')"  prop="txt" >
                    <el-select  v-model="invObj.tax"   class="rowcss">
                        <el-option v-for="(item,index) in taxArr" :key="index" :label="item.CNAME" :value="item.SUBNO"></el-option>
                    </el-select>
                </FormItem>
                <!-- <FormItem label="报销人员"  prop="empno" > 
                    <el-select  v-model="invObj.empno"   class="rowcss" filterable>
                        <el-option v-for="(item) in empArr" :label="item.EMPNM" :value="item.IDSEQ" :key="item.IDSEQ"> </el-option>
                    </el-select>
                </FormItem> -->
                <!-- <FormItem label="报销原由"  prop="rsn" > 
                    <el-input  v-model="invObj.rsn"    class="rowcss"></el-input>
                </FormItem> -->
                <FormItem :label="$LANG('0067', '抵扣月份')"  prop="mth" >
                    <el-input  v-model="invObj.mth"    class="rowcss"></el-input>
                </FormItem>
                <!-- <FormItem label="凭证号码"  prop="debitno" > 
                    <el-input  v-model="invObj.debitno"    class="rowcss"></el-input>
                </FormItem>          -->
            </Form>
 
            <div style="height:40px;line-height:30px;border-top:2px solid #ccc;padding-top:4px; " >
                <span style="float:right">
                    <el-button type="info" size="small" icon="iconfont icon-shanchu"  @click="addModel=false" style="margin-right:25px;">{{ $LANG('0132', '取消') }}</el-button>
                    <el-button :disabled="addBool||saveFlag"  type="primary" size="small" icon="iconfont icon-baocun"  @click="invSave" style="margin-right:10px;">{{ $LANG('0130', '保存') }}</el-button>
                </span>
            </div>
        </el-dialog> 
        <el-dialog class="pub_dialog" v-dialogDrag :show-close="false" :visible.sync="editModel" width="900px" :close-on-press-escape="false" :close-on-click-modal="false" append-to-body top="4vh">
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'38px'}">
                <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">{{ $LANG('0921', '编辑记录') }} </span>
            </div>
            <div style="height:88vh;overflow-y:auto">
                <Form ref="editForm" :model="formCol" :label-width="110"  :rules="ruleValidate"  label-position="right" inline >
                    <span v-for="(item,index) in invArr" :key="index" >
                        <FormItem :label="item.title" :prop="item.key" v-if="item.fhide==='N'" class="item-width">                                  
                            <el-date-picker type="date" v-if="item.edcss==='date'"   v-model="formCol[item.key]" value-format="yyyy-MM-dd" style="width:100%" ></el-date-picker> 
                            <el-select v-else-if="item.key==='INVTY'" v-model="formCol[item.key]" style="width:100%" >
                                <el-option :label="$LANG('1530', '增值税电子普通发票')" value="10"></el-option>
                                <el-option :label="$LANG('1365', '增值税普通发票')" value="04"></el-option>
                                <el-option :label="$LANG('1364', '增值税专用发票')" value="01"></el-option>
                            </el-select>
                            <el-select v-else-if="item.key==='TAX'" v-model="formCol[item.key]"  @change="taxSel" style="width:100%" >
                                <el-option v-for="(item ) in taxArr" :key="item.SUBNO" :label="item.CNAME" :value="item.SUBNO"></el-option>
                            </el-select>
                            <el-select v-else-if="item.key==='SUPNO'" v-model="formCol[item.key]" clearable filterable style="width:100%">
                                <el-option v-for="(item,index) in supArr" :key="index" :label="item.SUPNM" :value="item.IDNO"></el-option>
                            </el-select>
                            <el-select v-else-if="item.key==='INVTYPE'" v-model="formCol[item.key]"   style="width:100%">
                                <el-option v-for="(item,index) in typeArr" :key="index" :label="item.CNAME" :value="item.CODE"></el-option>
                            </el-select>
                            <el-select v-else-if="item.key==='EMPNO'" v-model="formCol[item.key]"   style="width:100%" filterable>
                                <el-option v-for="(item) in empArr" :label="item.EMPNM" :value="item.IDSEQ" :key="item.IDSEQ"> </el-option>
                            </el-select>
                            <el-input v-else-if="item.key==='AMT'" type="text" @change="amtChg"  v-model="formCol[item.key]"  style="width:100%"  clearable/>
                            <el-input v-else type="text" :disabled="item.disabled==='Y'?true:false" v-model="formCol[item.key]"  style="width:100%"  clearable/>
                        </FormItem>  
                    </span>
                    <el-card style="width:100%">
                        <div slot="header">{{ $LANG('0234', '上传图片【图片大小不能超出2M】') }}</div>
                        <div style="display:flex">
                            <Upload ref="upload"
                                name="upfile"
                                :data="uploadData"
                                :show-upload-list="false"
                                :before-upload="beforeImgFile"
                                :on-success="successImgFile"
                                :on-progress="handleProgress"
                                :accept="Accept"
                                :format="['jpg','jpeg','png']"
                                :max-size="2048"
                                :on-format-error="handleFormatError"
                                :on-exceeded-size="handleMaxSize"
                                :with-credentials="true"
                                type="drag"
                                :action="uploadUrl"
                                style="display: inline-block;width:200px;margin-right:10px;vertical-align:middle; ">
                                    <div style="padding: 10px 0">
                                        <Icon type="ios-cloud-upload" size="100" style="color: #3399ff"></Icon>
                                        <p>{{ $LANG('1842', '将文件拖动此处或点击上传') }}</p>
                                    </div>
                            </Upload>
                            <div style="display:flex;flex-direction:column">
                                <div style=" width:210px;height:120px;margin-left:30px;border:1px solid #ccc">
                                    <el-image fit="scale-down"  style="width:210px;  height:119px;vertical-align:middle" :src="imgSrc" > </el-image>
                                </div>
                                <div style="margin-left:30px;line-height:25px;background:#f8f8f9;height:25px">
                                    <i class="iconfont icon-chazhao" style="color:#409eff;margin-right:5px;"></i>
                                    <el-link :underline="false" @click="imgPreview">{{ $LANG('0141', '预览') }}</el-link>
                                </div>
                            </div>
                        </div>
                    </el-card>
                </Form>   
            </div>                  
            <div style="height:40px;line-height:30px;border-top:2px solid #ccc;padding-top:4px; ">
                <Button type="primary" style="margin-right:25px;"  @click="editModel=false">{{ $LANG('0132', '取消') }}</Button>
                <Button type="primary"   @click="inv_ok">{{ $LANG('1638', '确定') }}</Button>
            </div>
        </el-dialog> 
        <el-dialog :visible.sync="showViewer" width="800px" append-to-body>
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">{{ $LANG('0141', '预览') }}</span>
            </div>
            <el-image fit="scale-down"  style=" margin:5px auto;height:500px;width:100% " :src="listurl"></el-image>
        </el-dialog>
        <!-- 上传进度 -->
        <el-dialog :visible.sync="videoFlag" width="150px" append-to-body :show-close="false" :close-on-press-escape="false" :close-on-click-modal="false">
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'30px'}">
                <span style="line-height:30px;height:30px;font-size:16px;padding-left:5px;">{{ $LANG('2052', '正在上传中') }}...</span>
            </div>
            <el-progress   type="circle" :percentage="videoUploadPercent"  ></el-progress>  
        </el-dialog>
        <!-- 提示框 -->
        <el-dialog :show-close="false" :visible.sync="promptWin" width="400px" append-to-body :close-on-click-modal="false" :close-on-press-escape="false" >
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'35px'}">
                <span style="line-height:35px;height:35px;font-size:14px;padding-left:5px;">{{ $LANG('1442', '提示') }}</span>
            </div>
            <div style="line-height:30px;display:flex">
                <div style="width:40px; "><i class="iconfont icon-tishi1" style="color:#5cadff;font-size:36px"></i></div>
                <div style="font-size:12px;line-height:30px; ">{{prompt}}</div>
            </div>
            <div slot="footer">
                <Button type="primary"   @click="promptWin=false" style="margin-right:20px;">{{ $LANG('1638', '确定') }}</Button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    import {  getBaseData, getTabColOrData } from '../../api/user';
    import {getDate} from '../../api/Select'
    import createVeTableFieldSettingMixin from '@/utils/veTableFieldSettingMixin'
    import VeColumnConfigDialog from '@/components/VeTable/VeColumnConfigDialog.vue'
    import VeTableQueryHeader from '@/components/VeTable/VeTableQueryHeader.vue'
    import { buildVeTableFieldCondition, buildVeTableHeaderCondition, isVeTableMetadataField } from '@/utils/veTableHeaderQuery'
    export default {
        name: "invoice_mgt",
        mixins: [
            createVeTableFieldSettingMixin({
                settingFormId: '131',
                fieldIdseq: '131',
                fieldLstseq: '1',
                mainColumnKey: 'invArr',
                tableColumnKey: 'vueCol',
                initColumnKey: 'initCol',
                tableRef: 'tabref',
                generatedFixedColumnKeys: ['rownum', 'oper'],
            })
        ],
        components: { VeColumnConfigDialog },
        props: {
            v_cond :{type:String,default:''}
        },
        data(){
            return {
                addModel:false,
                editModel:false,
                showViewer:false,//打开预览/关闭
                imgSrc:'/assets/authorize/upload.png',
                listurl:[],
                formCol:{}, //表格单行记录 model
                saveFlag:false,
                promptWin:false,
                prompt:'',
                // 初始化信息总条数
                dataCount:0,
                rowSize:50,
                Accept: "png,jpg,jpeg", //上传文件格式限制
                allData:[],
                invData:[], //发票明细数据
                invArr:[] ,//发票列
                initCol:[],
                vueCol:[],
                columnHiddenOption: { defaultHiddenColumnKeys: [] },
                rowStyleOption: { clickHighlight: true },
                cellStyleOption: { headerCellClass: () => 'table-head-cell-class', bodyCellClass: () => 'table-body-cell-class1' },
                v_headerRow:{},
                queryRequestId:0,
                headerSortKey:'',
                headerSortOrder:'',
                virtualScrollOption: { enable: false },
                goPage:'',
                current:1,
                loading:false,
                uploadData:{}, //上传数据
                uploadUrl: '/xuper_oss/ftpUpload_nocheck' ,

                pageList: [ {
                    value: 50,
                    label: '50'
                    }, {
                    value: 100,
                    label: '100'
                    }],
                form: {  // 
                    scancode: '',
                    idno:'',
                    invno:'',
                    invdttm: '',
                    amt:'',
                },
                invObj: {  // 
                    invty: '01',
                    idno:'',
                    invno:'',
                    invdttm: '',
                    amt:'',
                    empno:'',
                    rsn:'',
                    tax:'',
                    mth:'',
                    debitno:'',
                    invtype:'',
                    corpnm:this.$cookies.get('v_corpid'),
                },
                invModel:false,
                tooltip:false,
                v_corpnm:this.$cookies.get('v_corpid'), //api 请求用户
                v_username:this.$cookies.get('v_telno'), //api 请求用户
                
                v_url:'xuper_auth/getTableRecMany', //动态请求url接口
                txtparam:'',
                selparam:'IDNO',
                v_ttlamt:0,
                oper:'like',
                txtparam2:'',
                selparam2:'',
                oper2:'like',
                empArr:[] , //报销人
                supArr:[],
                taxArr:[],
                typeArr:[], //分类
                ruleValidate:{
                    idno: [{ required: true,  trigger: 'blur' }],
                    invno: [{ required: true,  trigger: 'blur' }],
                    invdttm: [{ required: true,  trigger: 'blur' }],
                    amt: [{ required: true,  trigger: 'blur' }],
                },
                addBool:false, //新增,为true时--禁止
                editBool:false, //编辑,为true时--禁止
                delBool:false, //删除 ,为true时--禁止
                cfmBool:false, //审核 ,为true时--禁止
                cancelBool:false, //作废 ,为true时--禁止 
                v_admin:this.$cookies.get('v_admin') ,// 
                videoFlag:false,
                videoUploadPercent:0,
                operArr:[],
            }
        },
        created(){
           // console.log(jsuuid())
            if (this.v_username){ 
                //查询数据
                this.getInvList(this.v_cond+' order by adddttm desc')
            }else{
                let routeUrl = this.$router.resolve({
                    path: '/login',
                    query: {},
                });
                window.open(routeUrl.href, '_self');
            }
        },
        watch: {
            v_cond:function(){
                this.getInvList(this.v_cond+' order by adddttm desc')
            }
        },
        mounted(){
            this.$refs['scan'].focus()
            //操作符
            getBaseData('xuper_auth/getBaseData','PARENTNO','15995','','','v_sys_base','').then(res=>{
                this.operArr =res.result
            })
            //税率
            getBaseData('xuper_auth/getBaseData','parentno','249' ,'','','v_sys_base','').then(res=>{
                this.taxArr =res.result
            })
            //发票分类
            getBaseData('xuper_auth/getBaseData','parentno','290' ,'','','v_sys_base','').then(res=>{
                this.typeArr =res.result
            })
            //报销人员
            getBaseData('xuper_auth/getBaseData','corpid',this.v_corpnm ,'','','v_hr_emp','').then(res=>{
                this.empArr =res.result
            })
            //供应商
            getBaseData('xuper_auth/getBaseData','corpid',this.v_corpnm ,'','','v_bs_sup','').then(res=>{
                this.supArr =res.result
            })
            this.getTabField()
             //用户表单新增、编辑、审核、作废权限 :frmid:94供应商资料ID
            getBaseData(this.v_url,'userno',this.v_username,'frmidseq','131','v_sys_user_priv','').then(res=>{           
                if (this.v_admin==='N') { //表示有权限控制
                    let row =res.result[0]
                    if (row.ISADD==='N'){ //新增
                        this.addBool=true
                    }if (row.ISUPD==='N'){ //修改
                        this.editBool=true
                    }if (row.ISDEL==='N'){ //删除
                        this.delBool=true
                    }if (row.ISCFM==='N'){ //审核
                        this.cfmBool=true
                    }if (row.ISCANCEL==='N'){ //作废
                        this.cancelBool=true
                    }
                }
            }) 
        },
        computed:{
 
            tabHeight(){
                return (window.innerHeight-200)+ 'px'
            }  

        },
        destroyed(){
        },
        methods:{
            sortHeaderColumn(column, edcss){
                const key =column && column.key
                if (!key || !isVeTableMetadataField(this.initCol, key)) return
                if (this.headerSortKey === key) {
                    this.headerSortOrder =this.headerSortOrder === 'asc' ? 'desc' : 'asc'
                }else{
                    this.headerSortKey =key
                    this.headerSortOrder ='asc'
                }
                const direction =this.headerSortOrder === 'asc' ? 1 : -1
                const type =String(edcss || '').toLowerCase()
                this.invData.sort((left, right) => {
                    const leftValue =left[key]
                    const rightValue =right[key]
                    if (leftValue === rightValue) return 0
                    if (leftValue === null || leftValue === undefined || leftValue === '') return 1
                    if (rightValue === null || rightValue === undefined || rightValue === '') return -1
                    if (type === 'number') return (Number(leftValue) - Number(rightValue)) * direction
                    if (type === 'date' || type === 'date2' || type === 'time') {
                        return (new Date(leftValue).getTime() - new Date(rightValue).getTime()) * direction
                    }
                    return String(leftValue).localeCompare(String(rightValue), undefined, { numeric: true }) * direction
                })
            },
            //上传显示进度
            handleProgress(event,file,fileList){
                this.videoFlag = true
                this.videoUploadPercent = Math.floor(event.percent)
            },
            //图片预览
            imgPreview(){
                this.showViewer=true
                this.listurl=[this.imgSrc]
            },
 
            //文件超出指定文件大小限制的钩子
            handleMaxSize (file) {
                this.prompt =file.name + ' '+this.$LANG('1561', '文件太大， 不能超出')+'2M'
                this.promptWin =true
            },
            //文件格式验证错误时的钩子
            handleFormatError (file) {
                this.prompt =this.$LANG('1455', '文件格式错误')+','+file.name + ' '+this.$LANG('1431', '是不正确， 请选择图片或PDF格式')
                this.promptWin =true
            },
            // 文件上传成功时的钩子
            successImgFile(res,file){
                this.videoUploadPercent=0
                this.videoFlag = false
                let suffix=file.name.substring(file.name.lastIndexOf('.')).toLowerCase()
                let path='assets/basedict/'+this.formCol.IDSEQ+'-img'+suffix 
                this.imgSrc =path 
            },
            //上传文件之前的钩子
            beforeImgFile (res, file) {            
                this.uploadData = {
                    code: this.formCol.IDSEQ+'-img' ,
                    p_table:'inv',
                    p_idseq:this.formCol.IDSEQ,
                    p_user:this.v_username,
                    p_type:'img'
                }
                let promise = new Promise(resolve => {
                this.$nextTick(function() {
                        resolve(true);
                        this.$refs.upload.clearFiles()
                    });
                });
                return promise;   
            },
            //税率变更
            taxSel(val){
                let val_=this.formCol['AMT'] * val/100                
                this.formCol['TAXAMT'] = val_.toFixed(2)
            },
            amtChg(val){
                let val_=this.formCol['TAX'] * val/100                
                this.formCol['TAXAMT'] = val_.toFixed(2)
            },
            //导出
            expExcel(){
               this.loading =true
               require.ensure([], () => {
                    const { export_json_to_excel } = require('../../plugin/Export2Excel');
                    let tHeader = [] ,filterVal=[]
                    for(let k=0 ;k<this.invArr.length;k++){
                        tHeader.push(this.invArr[k].title) //设置Excel的表格第一行的标题
                        filterVal.push(this.invArr[k].key) //tableData里对象的属性
                    }
                    const list = this.invData;  //把data里的invData存到list
                    const data = this.formatJson(filterVal, list);
                    const fileName='发票_'+getDate()
                    export_json_to_excel(tHeader, data, fileName);
                    this.loading =false
                })
            },
            formatJson(filterVal, jsonData) {
                return jsonData.map(v => filterVal.map(j => v[j]))
            },
            //扫描保存
            scanTwo(){
                let code_=this.form.scancode,vm=this
                try{
                    let count = code_.match(/,/g).length
                    if (count!==8){
                        this.prompt =this.$LANG('1452', '错误的格式')
                        this.promptWin =true
                    }else{
                        let array=code_.split(',')
                        // for(let k =0;k<array.length;k++){
                        //     console.log(array[k])
                        // }
                        let invObj={corpnm:this.v_corpnm,invty:array[1],idno:array[2],invno:array[3],amt:array[4],invdttm:array[5],chkno:array[6]}
                        this.$axios({
                            method: 'post',
                            url:'xuper_auth/formOneSave',
                            data: {p_json:JSON.stringify(invObj), p_table:'inv',frmid:'131'},
                        }).then(res=>{      
                            if(res.code ==='200')  {                                     
                                vm.getInvList(vm.v_cond+' order by adddttm desc')  
                                this.form.scancode=''      
                            }else{
                                if (res.result.indexOf('ORA-00001')>-1){
                                    this.$alert(this.$LANG('1111', '此发票号码：')+array[3]+this.$LANG('1648', ' 已存在,请核查'), this.$LANG('1442', '提示'), {
                                        confirmButtonText: this.$LANG('1638', '确定'),
                                        showClose:false,
                                        type:'info'
                                    })
                                }else{ //
                this.$alert(res.result, this.$LANG('1442', '提示'), {
                    confirmButtonText: this.$LANG('1638', '确定'),
                                        showClose:false,
                                        type:'info'
                                    })
                                }
                                this.form.scancode=''
                            }   
                        })
                    }
                }catch(err){
                    //console.log(err)
                    this.tooltip=true
                    setInterval(()=>{
                        this.tooltip=false
                    },2000)
                }
 
            },
            //跳至页面
            goNext(){
                if (this.goPage){
                    this.changePage(this.goPage)
                    this.current =Number(this.goPage)
                }else{
                    this.$alert(this.$LANG('1721', '请输入跳至页数'), this.$LANG('1442', '提示'), {
                        confirmButtonText: this.$LANG('1638', '确定'),
                        showClose:false,
                        type:'info'
                    })
                }
            },
            //初始化查询页条数
            initPage(){
                //产品明细
                this.dataCount =this.allData.length //总条数
                // 初始化显示，小于每页显示条数，全显，大于每页显示条数，取前每页条数显示
                if (this.allData.length < this.rowSize){
                    this.invData = this.allData          
                }else{
 
                    if (this.current >1){
                        this.changePage(this.current)
                    }else{
                        this.invData =this.allData.slice(0,this.rowSize) //返回选定元素的子数组，不包含结尾元素
                    }
                }
            },
            //表格页面导航
            changePage(index){
                var _start = ( index - 1 ) * this.rowSize;
                var _end = index * this.rowSize
                this.current =index
                this.invData = this.allData.slice(_start,_end);
            },
            resetData(){
                this.selparam=''
                this.selparam2=''
                this.txtparam=''
                this.txtparam2=''
            },
            //查询
            qryTabData(){
                let cond_= this.v_cond + buildVeTableHeaderCondition(this.initCol, this.v_headerRow)
                cond_+=buildVeTableFieldCondition(this.initCol, this.selparam, this.txtparam, this.oper)
                cond_+=buildVeTableFieldCondition(this.initCol, this.selparam2, this.txtparam2, this.oper2)
                this.current = 1
                this.getInvList(cond_)
            },
            rowShow(){ this.v_headerRow={}; this.qryTabData() },
            //编辑
            editTab(row){
                console.log('IDSEQ:'+row.IDSEQ)
                this.formCol =JSON.parse(JSON.stringify(row))
                this.editModel =true
                if (row.IMGPATH){
                    this.imgSrc =row.IMGPATH
                }else{
                   this.imgSrc ='/assets/authorize/upload.png'
                }
            },
            //作废
            delTab(row,val){
                this.$Modal.confirm({
                    title: this.$LANG('0364', '确认'),
                    content: '<p>'+this.$LANG('1597', '你确定要作废此行记录吗')+'</p>',
                    onOk: () => {
                        //发起删除请求
                        var vm=this;
                        this.$axios({
                            method: 'post',
                            url:'xuper_auth/updateRec',
                            data: {p_key:'idseq',p_value:row.IDSEQ,p_table:'INV',p_cond:' set stfg=\''+val+'\'' },
                        }).then(res=>{      
                            if(res.code =='200')  {           
                                vm.qryTabData()     
                            }else{
                                this.prompt =res.message
                                this.promptWin =true
                            }        
                        }) 
                    }
                });
            },
            //编辑保存
            inv_ok(){
                let vm=this
                this.$axios({
                    method: 'post',
                    url:'xuper_auth/formOneSave',
                    data: {p_json:JSON.stringify(vm.formCol), p_table:'inv',frmid:'131'},
                }).then(res=>{      
                    if(res.result ==='OK')  {          
                        vm.editModel =false   
                        vm.qryTabData()                                  
                    }else{
                this.$alert(res.result, this.$LANG('1442', '提示'), {
                    confirmButtonText: this.$LANG('1638', '确定'),
                            showClose:false,
                            type:'info'
                        })
                    }        
                }) 
            },
            getFldKey(row){
                return row.IDSEQ
            },
            handAdd(){
                this.addModel=true
                this.invObj = {  // 
                    invty: '01',
                    idno:'',
                    invno:'',
                    invdttm: getDate('day'),
                    amt:'',
                    empno:'',
                    rsn:'',
                    mth:'',
                    debitno:'',
                    invtype:'293',
                    corpnm:this.$cookies.get('v_corpid'),
                }
            },
            //手工保存
            invSave(){
                let vm =this
                if(!this.invObj.idno){
                    this.prompt =this.$LANG('0633', '发票代码')+this.$LANG('2051', '不能为空')
                    this.promptWin =true
                }else if(!this.invObj.invno){
                    this.prompt =this.$LANG('0635', '发票号码')+this.$LANG('2051', '不能为空')
                    this.promptWin =true
                }else if(!this.invObj.invdttm){
                    this.prompt =this.$LANG('0023', '开票日期')+this.$LANG('2051', '不能为空')
                    this.promptWin =true
                }else if(!this.invObj.amt){
                    this.prompt =this.$LANG('0408', '金额')+this.$LANG('2051', '不能为空')
                    this.promptWin =true
                }else{
                    this.$axios({
                        method: 'post',
                        url:'xuper_auth/formOneSave',
                        data: {p_json:JSON.stringify(vm.invObj), p_table:'inv',frmid:'131'},
                    }).then(res=>{      
                        if(res.code ==='200')  {          
                            vm.addModel =false                             
                            vm.getInvList(vm.v_cond+' order by adddttm desc')        
                        }else{
                            if (res.result.indexOf('ORA-00001')>-1){
                                this.$alert(this.$LANG('1111', '此发票号码：')+this.invObj.invno+this.$LANG('1648', ' 已存在,请核查'), this.$LANG('1442', '提示'), {
                                    confirmButtonText: this.$LANG('1638', '确定'),
                                    showClose:false,
                                    type:'info'
                                })
                            }else if (res.result.indexOf('ORA-06512')>-1){
                                this.$alert(this.$LANG('1873', '填写金额是无效的数字,请核查'), this.$LANG('1442', '提示'), {
                                    confirmButtonText: this.$LANG('1638', '确定'),
                                    showClose:false,
                                    type:'info'
                                })
                            }else{ //
                this.$alert(res.result, this.$LANG('1442', '提示'), {
                    confirmButtonText: this.$LANG('1638', '确定'),
                                    showClose:false,
                                    type:'info'
                                })
                            }
                        }        
                    }) 
                }
            },
            //获取主表字段并应用用户字段设置
            getTabField(){
                const vm = this
                getTabColOrData(this.v_url,'v_sys_form_fld','idseq','131','lstseq','1','','',' order by sortby,lstseq').then(res => {
                    vm.initCol = res.result || []
                    return vm.loadInitialFieldSettings().then(() => {
                        const fieldRows = vm.sortFieldRows(vm.initCol)
                        vm.invArr = []
                        vm.vueCol = []
                        fieldRows.forEach(item => {
                            const title = vm.$translate.getColTitle(item, vm.$store.state.lang)
                            vm.invArr.push({
                                title,
                                key: item.key,
                                align: item.align,
                                edcss: item.EDCSS,
                                width: item.width,
                                thide: item.THIDE,
                                fhide: item.FHIDE,
                                disabled: item.DISABLED,
                            })
                            if (String(item.THIDE).toUpperCase() !== 'N') return
                            vm.vueCol.push({
                                field: item.key,
                                key: item.key,
                                title,
                                align: item.align,
                                width: Number(item.width) || 120,
                                sortable: false,
                                ellipsis: { showTitle: true },
                                renderHeaderCell: ({column}) => <VeTableQueryHeader title={column.title} edcss={item.EDCSS} value={this.v_headerRow[item.key]} operator={this.v_headerRow[`#OPER${item.key}`]} on-input={(value) => this.$set(this.v_headerRow, item.key, value)} on-operator-change={(value) => this.$set(this.v_headerRow, `#OPER${item.key}`, value)} on-query={this.qryTabData} sortable={item.key !== 'RN' && item.EDCSS !== 'checkbox'} sortOrder={vm.headerSortKey === item.key ? vm.headerSortOrder : ''} on-title-click={() => vm.sortHeaderColumn({ key: item.key }, item.EDCSS)} />,
                                renderBodyCell: ({row}) => item.EDCSS === 'checkbox'
                                    ? <el-checkbox disabled true-label="Y" false-label="N" v-model={row[item.key]}></el-checkbox>
                                    : row[item.key],
                            })
                        })
                        vm.vueCol.unshift({ field:'index', key:'rownum', title:vm.$LANG('0310', '序号'), width:55, align:'center', fixed:'left', disableResizing:true, renderBodyCell:({rowIndex}) => rowIndex + 1, renderHeaderCell:({column}) => <div><div style="margin-top:3px">{column.title}</div><el-link on-click={this.rowShow} style="font-size:12px;color:#404eff;height:30px"><el-tooltip content={this.$LANG('0852', '清除条件')} effect="light"><i class="iconfont icon-shanchu1"></i></el-tooltip></el-link></div> })
                        vm.vueCol.push({
                            field: 'oper0',
                            key: 'oper',
                            title: vm.$LANG('0330', '操作'),
                            width: 210,
                            align: 'center',
                            fixed: 'right',
                            disableResizing: true,
                            renderBodyCell: ({row}) => (
                                <div>
                                    <i class="iconfont icon-chakan" style="color:#409EFF;font-size:14px;margin-right:5px;"></i>
                                    <el-link on-click={() => vm.editTab(row, 0, 'Y')} underline={false}><span style="font-size:11px;margin-right:5px;">{vm.$LANG('0139', '查看')} </span></el-link>
                                    <i class="iconfont icon-bianji" style="color:#409EFF;font-size:14px;margin-right:5px;"></i>
                                    <el-link disabled={vm.editBool} on-click={() => vm.editTab(row, 0, 'N')} underline={false}><span style="font-size:11px;margin-right:5px;">{vm.$LANG('1639', '编辑')} </span></el-link>
                                    {row.STFG !== 'X' ? <span>
                                        <i class="iconfont icon-shanchu1" style="color:#409EFF;font-size:14px;margin-right:5px;margin-left:5px;"></i>
                                        <el-link disabled={vm.cancelBool} on-click={() => vm.delTab(row, 'X')} underline={false}><span style="font-size:11px;">{vm.$LANG('0257', '作废')} </span></el-link>
                                    </span> : <span>
                                        <i class="iconfont icon-chexiao_icon" style="color:#409EFF;font-size:14px;margin-right:5px;margin-left:5px;"></i>
                                        <el-link disabled={vm.cancelBool} on-click={() => vm.delTab(row, 'Y')} underline={false}><span style="font-size:11px;">{vm.$LANG('0444', '反作废')} </span></el-link>
                                    </span>}
                                </div>
                            ),
                        })
                        vm.applyFieldSettingRows()
                    })
                })
            },
            ///发票明细
            getInvList(cond){
                this.loading =true
                const requestId = ++this.queryRequestId
                //获取所有产品记录且初始化分页记录
                this.$axios({   
                    method: 'post',
                    url:'xuper_auth/getBaseData',
                    data: {p_key:'stfg', p_value:'Y',p_key2:'corpnm', p_value2:this.v_corpnm,p_cond:cond,p_table:'v_inv'},
                }).then(res=>{ 
                    if (requestId !== this.queryRequestId) return
                    if (res.code==='200'){
                        this.allData =res.result
                        this.v_ttlamt =0
                        let amt_=0
                        this.allData.forEach(item=>{
                            amt_= amt_+Number(item['TTLAMT'])
                        })
                        this.v_ttlamt =amt_.toFixed(2)
                        this.initPage()
                    }else{
                this.$alert(res.result, this.$LANG('1442', '提示'), {
                    confirmButtonText: this.$LANG('1638', '确定'),
                            showClose:false,
                            type:'info'
                        })
                    }
                    this.$nextTick(() => {
                        const table = this.$refs.tabref
                        if (table && typeof table.doLayout === 'function') table.doLayout()
                    })
                }).catch((error) => {
                    if (requestId === this.queryRequestId) this.$alert(error.message || this.$LANG('1641', '查询失败'), this.$LANG('1442', '提示'))
                }).finally(() => {
                    if (requestId === this.queryRequestId) this.loading=false
                })
            },
 
        }
    }
</script>
<style lang="less">
    .custom-table-border .el-table__body td, .custom-table-border .el-table__header th {
        border-color: rgb(184, 181, 181);
        border-width: 1px;
    }
    .el-table {
        th {
            padding: 0 ;
        }
        thead{
            height: 15px !important;
            color:rgb(128,128, 128);
            font-size:12px;
        }
        td {
            padding: 5px ;
            font-size:11px;
        }   
    }
    .el-checkbox__input.is-disabled.is-checked .el-checkbox__inner::after{
        border-color :#3d77eb
    }
    .el-checkbox__input.is-disabled+span.el-checkbox__label{
        color:#3d77eb
    }
    .el-header, .el-footer {
        background-color: white;
        color: #333;
        line-height:200px;
    }
  .el-main {
    background-color: white;
    color: #333;
    text-align: center;
    margin-top:2px;
  }
  .el-dialog__body{
        padding: 10px;
    }
    .el-dialog__header{
        padding: 0px;
    }
    .el-dialog__footer{
        padding: 5px;
        border-top:1px solid #ccc;
    } 
    .el-dialog__headerbtn{font-size: 20px; background:white;top:5px !important;}
    .ve-list-page {
        display: flex;
        flex-direction: column;
        height: calc(100% - 32px);
        min-height: 0;
        overflow: hidden;
        background: white;
    }
    .invoice-mgt-toolbar {
        align-items: center;
        flex-wrap: nowrap;
    }
    .invoice-mgt-toolbar__action {
        display: inline-flex;
        align-items: center;
        flex: 0 0 auto;
        white-space: nowrap;
    }
    .invoice-mgt-toolbar__field-icon {
        flex: 0 0 auto;
        line-height: 1;
    }
    .ve-list-page__table {
        flex: 1 1 auto;
        min-height: 0;
        overflow: hidden;
    }
    .ve-list-page__table > .vue-table-root {
        height: 100%;
    }
    .ve-list-page__table /deep/ .ve-table,
    .ve-list-page__table /deep/ .ve-table-container {
        height: 100% !important;
        max-height: 100% !important;
    }
    .ve-list-page__pagination {
        flex: 0 0 38px;
        min-height: 38px;
        overflow: hidden;
        display: flex;
        align-items: flex-start;
        background: white;
        font-size: 12px;
        padding-top: 3px;
        box-sizing: border-box;
    }
</style>
 
<style scoped lang="less">
    .rowcss{
        width:340px;
        height:35px;
    }
    .item-width  {
        width: 48%;
    }
     .pub_dialog {
        display: flex;
        justify-content: center;
        align-items: Center;
        overflow: hidden;
        .el-dialog {
            margin: 0 auto !important;
            height: 90%;
            overflow: hidden;
            .el-dialog__body {
                position: absolute;
                left: 0;
                top: 54px;
                bottom: 0;
                right: 0;
                padding: 0;
                z-index: 1;
                overflow: hidden;
                overflow-y: auto;
            }
        }
    }
</style>
